/**
 * The open planner, as the app-wide `where_am_i` reports it
 * (projects/yates-planner D14). The editor's WebMCP hook sets a reader
 * while it is mounted; `where_am_i` (registered by the shell, which can't
 * see the editor's state) asks it.
 *
 * Ids only — the plan id, the floor id, the selected element's id — never a
 * name someone wrote, so `where_am_i` stays free of untrusted text.
 */

let current = null;

/** Set `read` as the open planner's reader; returns the release (a later
 * page's reader is never cleared by an earlier page's release). */
export function setPlannerPage(read) {
  const entry = { read };
  current = entry;
  return () => {
    if (current === entry) current = null;
  };
}

/** What the open planner reports, or null when none is open. */
export function readPlannerPage() {
  try {
    return current ? current.read() : null;
  } catch {
    return null;
  }
}
